import { AxiosInstance } from 'axios';
import { toast } from 'react-toastify';
import { defaultToastOptions } from '../../../Hooks/useToastify/useToastify';

const throwIfAccessIsForbiddenAcceptatieAPP = (instance: AxiosInstance) => {
    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error?.response) {
                const { config, status } = error?.response;
                if (config.url?.includes('review') && [403, 401].includes(status)) {
                    toast.error("You don't have access to this action!", defaultToastOptions);
                }
            }
            throw error;
        },
    );
};

export default throwIfAccessIsForbiddenAcceptatieAPP;
